export class DictionaryHelper {

    public static ToArray<T> (dictionary: {[key: string]: T}): T[] {

        let array: T[] = Object
            .keys(dictionary)
            .map(key => dictionary[key]);

        return array;

    }

}


// WEBPACK FOOTER //
// ./source/ts/helpers/dictionary.ts